module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "pro01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("PROLOGUE")])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("M"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("AGGIE")])]), _vm._v(" T"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("RENT")])]), _vm._v(" and Jack McKinnon conducted rather unreal conversations at times.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Why this should be so had something to do with the unreal nature of their relationship, Maggie felt. Nothing ever went according to plan in their lives. Their first meeting had been sheer coincidence, their second meeting sheer disaster, their third meeting should have had labels stuck all over it shouting, ‘Spoilt, little rich girl determined to get her own way’—according, at first anyway, to Jack.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They’d parted after that extended meeting, not well, and determined never wittingly to come together again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Yet just under a year later Maggie began one of her unreal conversations with Jack McKinnon on the subject of their two-month-old son who had started out life known as Trent/McKinnon—it had been written on his wrist band and on the label on his cot. They’d dispensed with the stroke after a week but stuck with the Trent McKinnon.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The gist of their conversation was this.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘This is a very proper baby,’ Maggie said seriously one evening.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I never thought he was a porcelain doll.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No. I mean, he’s very well organized. He does everything by the book.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jack frowned. ‘He’s only eight weeks old. How can you say that?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Maggie was attractively dressed in slim white trousers and a floral seersucker jacket trimmed with green. Her dark gold hair was tied back with a green scrunchie; her green eyes were clear and she was sitting beside a cot.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Trent McKinnon was asleep in the cot.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I’ll tell you. He adapted himself to a four-hourly schedule right from the start under extremely difficult circumstances. He burps beautifully and he mostly sleeps between feeds just as the book says he should. He has one wakeful period, after his two p.m. feed, where he’ll accept conversation and he quite appreciates being carried around for a bit. He now sleeps through the eight hours from ten p.m. to six a.m.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Is there anything he doesn’t do by the book?’ Jack asked with a grin. ‘He sounds almost too good to be true.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Maggie considered. ‘He hates having his hair washed. He gets extremely upset, but even that isn’t going against the book exactly. They do warn that some babies hate it.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Screams blue murder?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Yes. Otherwise—’ she shrugged ‘—there’s nothing he doesn’t do very correctly.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘What are you worried about, then?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Maggie stared down at her sleeping son with her heart in her eyes. ‘I can’t help thinking he would be horrified if he knew how—irregular—his situation was.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She looked up and their gazes clashed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Born out of wedlock, you mean?’ he said, and for a fleeting moment his mouth hardened. ‘That was your choice, Maggie.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She inclined her head. ‘That was before—all sorts of things happened,’ she said quietly and ran her fingers along the arm of her chair. ‘That was definitely before I came to appreciate the reality of having a baby and what a baby deserves.’")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bee58c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/richmansvirginthe_pro01.vue
// module id = 63
// module chunks = 0